export default __webpack_public_path__ + "static/media/tech-advisor-plus.59d6d3ef.png";